import React from 'react';
import { Box, Typography } from '@material-ui/core';

const SectionHeader = ({ title, subtitle, rightSlot }) => (
  <Box display="flex" justifyContent="space-between" alignItems="flex-end" mb={2} flexWrap="wrap">
    <Box mb={1}>
      <Typography variant="h5">{title}</Typography>
      {subtitle && <Typography color="textSecondary">{subtitle}</Typography>}
    </Box>
    {rightSlot}
  </Box>
);

export default SectionHeader;
